// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './app.vue'
import Vue2Filters from 'vue2-filters'
import VueTailwind from 'vue-tailwind'
import router from './router'
import * as config from './shared/config/config'
import * as tailwindVueConfig from './shared/config/config-tailwind-vue'
import AuditsService from './admin/audits/audits.service'

import HealthService from './admin/health/health.service'
import MetricsService from './admin/metrics/metrics.service'
import LogsService from './admin/logs/logs.service'
import UserManagementService from '@/admin/user-management/user-management.service'
import MarketPlaceUserService from '@/marketplace/users/users.service'

import AccountService from './account/account.service'

import Dropdown from '@/shared/dropdown/dropdown.vue'
import ActionBar from '@/core/action-bar.vue'

import TranslationService from '@/locale/translation.service'
import ConfigurationService from '@/admin/configuration/configuration.service'
import { Tracker } from './shared/plugins/tracker'
import ThorConfigService from '@/marketplace/thor/thor.service'
// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

Vue.config.productionTip = false
config.initVueApp(Vue)
config.initFortAwesome()
tailwindVueConfig.initTailwindVue(Vue)
Vue.use(Vue2Filters)
Vue.use(VueTailwind)
Vue.use(Tracker)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('jhi-item-count', () => import(/* webpackChunkName: "smart-table-components" */ '@/shared/jhi-item-count.vue'))
Vue.component('jhi-sort-indicator', () => import(/* webpackChunkName: "smart-table-components" */ '@/shared/sort/jhi-sort-indicator.vue'))
Vue.component('mc-modal', () => import(/* webpackChunkName: "main-micro-components" */ '@/shared/modal.vue'))
Vue.component('mc-dropdown', Dropdown)
Vue.component('mc-dropdown-item', () => import(/* webpackChunkName: "main-micro-components" */ '@/shared/dropdown/dropdown-item.vue'))
Vue.component('mc-progress', () => import(/* webpackChunkName: "progress" */ '@/shared/progress.vue'))
Vue.component('mc-action-bar', ActionBar)

const i18n = config.initI18N(Vue)
const store = config.initVueXStore(Vue)

const translationService = new TranslationService(store, i18n)
const accountService = new AccountService(store, router)

// eslint-disable-next-line id-length
router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found')
  }

  // if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
  //   if (!accountService.hasAnyAuthority(to.meta.authorities)) {
  //     sessionStorage.setItem('requested-url', to.fullPath)
  //     next('/forbidden')
  //   } else {
  //     next()
  //   }
  // } else {
  //   // no authorities, so just proceed
  //   next()
  // }
  next()
})

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    userService: () => new UserManagementService(),
    marketPlaceUserService: () => new MarketPlaceUserService(),
    thorConfigService: () => new ThorConfigService(),
    auditsService: () => new AuditsService(),

    healthService: () => new HealthService(),

    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),
    translationService: () => translationService,
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
  },
  i18n,
  store,
})
